import React, { useEffect, useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Button,
  Select,
  MenuItem,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Pagination,
} from "@mui/material";

import { Chip } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CustomCardForDashboard from "../../../Global_Component/customModuleComponent";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import { Person } from "@mui/icons-material";
import PersonAddOutlinedIcon from '@mui/icons-material/PersonAddOutlined';
import OutboxOutlinedIcon from '@mui/icons-material/OutboxOutlined';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import NewLeadsTable from "./cache";
import ApprovedApplicationTable from "./cache2";


const data = [
  { department: "CRM", achieved: 20, target: 40, color: "#EAE2F8" },
  { department: "R&D Pre audit", achieved: 5, target: 30, color: "#F8E2E7" },
  { department: "Finance", achieved: 12, target: 40, color: "#FFE8E8" },
  { department: "Audit", achieved: 20, target: 40, color: "#E8F8F1" },
  { department: "R&D Post audit", achieved: 2, target: 40, color: "#FFF4E5" },
  { department: "Shariah", achieved: 35, target: 40, color: "#E3F2FF" },
];


const DashboardCRM = () => {
  return (
    <Box sx={{ height: "100%", overflowY: "auto", p: 3 ,bgcolor:"#EDF4F8"}}>
     
      <Grid sm={12}>
        <Grid container spacing={1.5}>
        

          {/* <Grid item xs={12} sm={6} md={3} >
            <CustomCardForDashboard
            lightTheme={'#E6F1FB'}
            darkTheme={'#0072DA'}
              title="New Leads"
              value="256"
              subtitle="45 % ↑"
              icon={<PersonIcon fontSize="medium" />}
            />
          </Grid> */}
          <Grid item xs={12} sm={6} md={3}>
            <CustomCardForDashboard
            lightTheme={'#EDEBF7'}
            darkTheme={'#8E7AF1'}
              title="Application"
              value="256"
              subtitle="12 % ↑"
              icon={<FolderOpenOutlinedIcon fontSize="medium" />}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomCardForDashboard
             lightTheme={'#E6F4F2'}
             darkTheme={'#008F78'}
              title="Approved Application"
              value="256"
              subtitle="45 % ↑"
              icon={<TaskOutlinedIcon fontSize="medium" />}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <CustomCardForDashboard
             lightTheme={"#FDF2F2"}
             darkTheme={"#F49B68"}
              title="Allocated To Finance"
              value="256"
              subtitle="45 % ↑"
              icon={<OutboxOutlinedIcon fontSize="medium" />}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid container sm={12} sx={{ my: 2 }} spacing={1}>
        {/* <Grid item sm={12}>
         
        <NewLeadsTable/>
        </Grid> */}
        <Grid item sm={12} sx={{overflow:"auto"}}>
          
         <ApprovedApplicationTable/>
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardCRM;
